import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SocketService } from '../../services/socket.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-esas-socket',
  templateUrl: './esas-socket.component.html',
  styleUrls: ['./esas-socket.component.scss'],
  standalone: false,
})
export class EsasSocketComponent implements OnInit {
  output: any;
  data: string;
  action: string;

  constructor(private socketService: SocketService) {}

  ngOnInit() {}

  sendMessage() {
    this.socketService.emit({ event: this.action, params: null });
  }
}
